import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import { type Dispatch } from 'redux';

import { type GetFromObjectsParams, type ScopedPermissions } from '@air/api';
import { setPermissionsAction } from '@air/redux-permissions';

/**
 * Saves permissions for all object scopes with values to the Redux store.
 * Iterates over objects and sets permissions in the Redux store for each scope.
 *
 * @param objects - The objects parameter containing scopes and their values
 * @param permissions - The fetched permissions to save
 * @param dispatch - The Redux dispatch function
 */
export const savePermissionsForObjectsToStore = (
  objects: GetFromObjectsParams<'all'>['objects'],
  permissions: { [key: string]: ScopedPermissions },
  dispatch: Dispatch,
): void => {
  for (const [scope, value] of Object.entries(objects)) {
    if (isArray(value) && value.length > 0) {
      dispatch(
        setPermissionsAction({
          [scope]: value.reduce<{
            [key: string]: ScopedPermissions;
          }>((curr, objectId) => {
            curr[objectId] = permissions[objectId];

            return curr;
          }, {}),
        }),
      );
    } else if (isString(value)) {
      const objectPermissions = permissions[value];

      dispatch(
        setPermissionsAction({
          [scope]: {
            [value]: objectPermissions,
          },
        }),
      );
    }
  }
};
